import React from 'react';

import Hashtag from '../../images/Hashtag';

import style from './Footer.scss';

import { Link } from 'gatsby';

export interface IFooterProps {
  tags: {
    node: {
      name: string;
      slug: string;
    };
  }[];
}

export default function FooterTags({ tags }: IFooterProps) {
  return (
    <div className={style.footerTags}>
      {tags.map((tag, index: number) => {
        const { name, slug } = tag.node;
        if (index < 30) {
          return (
            <Link to={`/tag/${slug}/`} key={index}>
              <Hashtag />
              {name}
            </Link>
          );
        }
      })}
    </div>
  );
}
